import type { AuthModel } from "../app/modules/auth/core/_models";

/**
 * Resolve numeric DB user_id for Reverb private channel subscription.
 * Prefer explicit db_user_id from Laravel login; fall back to legacy token prefix (5-digit padded id).
 */
export function resolveNumericUserId(auth: AuthModel | undefined): number | null {
    if (!auth) {
        return null;
    }

    const explicit = auth.db_user_id;
    if (explicit !== undefined && explicit !== null && Number(explicit) > 0) {
        return Number(explicit);
    }

    const token = auth.user_id;
    if (!token || token.length < 5) {
        return null;
    }

    const parsed = parseInt(token.slice(0, 5), 10);

    return Number.isNaN(parsed) || parsed <= 0 ? null : parsed;
}
